/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import {
  FetchCalendarMicrosoft,
  DeleteCalendarMicrosoft,
  RelationCalendarMicrosoft,
  PutCalendarMicrosoft,
  CleaningCalendarMicrosoft
} from '@/infrastructure/network/Monitaro/requests/calendar_microsoft'

export default class CalendarMicrosoft extends MonitaroGatewayBase {
  async FetchCalendarMicrosoft() {
    const { calendars } = await this.apiClient.request(new FetchCalendarMicrosoft())
    return calendars
  }

  async DeleteCalendarMicrosoft() {
    const { result } = await this.apiClient.request(new DeleteCalendarMicrosoft())
    return result
  }

  async RelationCalendarMicrosoft(id: string) {
    return await this.apiClient.request(new RelationCalendarMicrosoft(id))
  }

  async PutCalendarMicrosoft(id: string, checked: boolean) {
    const { result } = await this.apiClient.request(new PutCalendarMicrosoft(id, { checked }))
    return result
  }

  async CleaningCalendarMicrosoft(id: string) {
    const { result } = await this.apiClient.request(new CleaningCalendarMicrosoft(id))
    return result
  }
}
